
const ForgotPassword = ({ ...props }) => {



    return (
        <></>
        
  );
};
export default ForgotPassword;
